import React from 'react'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'

import {
  Panel,
  ProgressBar,
  TooltipLabel,
  Title,
  TITLE_VARIANT_L,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_LIGHT,
  Spinner,
  SpacingVertical,
  SPACING_24,
  SPACING_8,
  Flex,
  FlexItem
} from 'mailup-web-components'

import {
  BEQUEUE_CONFIG_STATE_COMPLETED,
  BEQUEUE_CONFIG_STATE_FAILED,
  BEQUEUE_CONFIG_STATE_RUNNING
} from 'Api/beQueueApi'

const BoxProgress = ({
  queueStatus,
  variant,
  queuedPercentage,
  toBeQueued
}) => {
  const intl = useIntl()

  const percentage = queuedPercentage + '% '

  return (
    <Panel collapsible={false}>
      <Flex width='90%' margin='auto' flexDirection='column'>
        <SpacingVertical variant={SPACING_24} />
        <Title variant={TITLE_VARIANT_L} textAlign='center'>
          {queueStatus === BEQUEUE_CONFIG_STATE_RUNNING && (
            <>
              <>
                {toBeQueued !== 0 ? intl.formatNumber(toBeQueued) : <Spinner />}
              </>{' '}
              <>
                {intl.formatMessage({ id: 'Load.QueueStatus.RecipientsNew' })}
              </>
            </>
          )}
          {queueStatus === BEQUEUE_CONFIG_STATE_COMPLETED && (
            <>
              <>
                {toBeQueued !== 0 ? intl.formatNumber(toBeQueued) : <Spinner />}
              </>{' '}
              <>
                {intl.formatMessage({ id: 'Load.QueueStatus.RecipientsDone' })}
              </>
            </>
          )}
          {queueStatus === BEQUEUE_CONFIG_STATE_FAILED && (
            <>
              <>--</>{' '}
              <>
                {intl.formatMessage({ id: 'Load.QueueStatus.RecipientsNew' })}
              </>
            </>
          )}
        </Title>
        <FlexItem alignSelf='flex-end'>
          <TooltipLabel variant={variant}>
            {queueStatus === BEQUEUE_CONFIG_STATE_FAILED && (
              <Text variant={TEXT_VARIANT_BOLD}>
                {intl.formatMessage({ id: 'Load.AsyncDetail.Error' })}
              </Text>
            )}
            {queueStatus === BEQUEUE_CONFIG_STATE_RUNNING && (
              <Text variant={TEXT_VARIANT_BOLD}>
                <>{percentage}</>
                <>
                  {intl.formatMessage({
                    id: 'Load.EmailSendingWizard.QueueProgress'
                  })}
                </>
              </Text>
            )}
            {queueStatus === BEQUEUE_CONFIG_STATE_COMPLETED && (
              <Text variant={TEXT_VARIANT_BOLD}>
                <>{percentage}</>
                <>
                  {intl.formatMessage({
                    id: 'Load.EmailSendingWizard.QueueProgress'
                  })}
                </>
              </Text>
            )}
          </TooltipLabel>
        </FlexItem>
        <SpacingVertical variant={SPACING_8} />
        <ProgressBar width={queuedPercentage} variant={variant} />
        <FlexItem margin='8px 0 0 0' width='90%' alignSelf='center'>
          <Text variant={TEXT_VARIANT_LIGHT}>
            {intl.formatMessage(
              { id: 'Load.QueueStatus.RecipientsProgress' },
              { strong: chunks => <strong>{chunks}</strong> }
            )}
          </Text>
        </FlexItem>
      </Flex>
    </Panel>
  )
}

BoxProgress.propTypes = {
  queueStatus: PropTypes.number,
  variant: PropTypes.string,
  queuedPercentage: PropTypes.number,
  toBeQueued: PropTypes.number
}

export default BoxProgress
